import { Checkbox } from '@material-ui/core';

import styled from 'styled-components';

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #e0e0e0;
  margin: 5px 0 10px 0;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const SectionTitle = styled.div`
  font-size: 20px;
  font-weight: 600;
  margin: 10px 0;
`;

export const OrderNumber = styled.div`
  font-size: 15px;
  font-weight: 600;
  margin: 0 0 15px 0;
  color: ${(props) => props.primaryColor};
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  margin: 0 0 15px 0;
`;

export const CustomCheckbox = styled(Checkbox)`
  color: ${(props) => props.color};
`;
